const getExample = () => {
    return `
    //EXAMPLE:
     <Your Code...>
        <AvatarMedal
            image="/static/mock-images/avatars/avatar-image.jpg"
            label="Hello World"
            textPosition="right"
            sublabel="Example"
        />
     </Your Code...>
    `;
}

export default getExample;
